// Navbar.js
import React, { Component } from "react";
import "./topbar.css";
import webLogo from "../../img/wikiworks-logo-White-Tag.png";
import { MenuItems } from "./menuItems";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import BookDemoModal from "../react_modal/reactModal";
import ContactModal from "../contact_us/contact_us"; // Import your ContactModal component
import { NavLink } from 'react-router-dom'; 
class Navbar extends Component {
  state = { 
    clicked: true, 
    modalIsOpen: false,
    contactModalIsOpen: false 
  };

  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };

  handleMenuClick = () => {
    this.setState({ clicked: true });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  openContactModal = () => {
    this.setState({ contactModalIsOpen: true, clicked: true });
  };

  closeContactModal = () => {
    this.setState({ contactModalIsOpen: false });
  };

  render() {
    return (
      <>
        <nav className="navbar-Items">
          <h1 className="navbar-Logo">
            <img height={40} src={webLogo} alt="logo" />
          </h1>
          <div className="menu-Icons" onClick={this.handleClick}>
            <i
              className={
                this.state.clicked ? "fa-solid fa-bars" : "fa-solid fa-xmark"
              }
            ></i>
          </div>

          <ul className={this.state.clicked ? "navbar-Menu" : "navbar-Menu active"}>
          {MenuItems.map((item, index) => {
  if (item.toName === "ContactUs") {
    return (
      <li key={index}>
      <NavLink
        to="#" // Or keep your actual path if needed
        className={item.cName}
        onClick={(e) => {
          e.preventDefault();
          this.openContactModal();
        }}
      >
        {item.title}
      </NavLink>
    </li>
    );
  }
  
  if (item.isExternal) {
    return (
      <li key={index}>
        <NavLink
          exact
          to={item.url}
          className={item.cName}
          activeClassName="active"
          onClick={this.handleMenuClick}
        >
          {item.title}
        </NavLink>
      </li>
    );
  }

  return (
    <li key={index}>
      <a
        className={item.cName}
        href={item.url}
        onClick={this.handleMenuClick}
      >
        {item.title}
      </a>
    </li>
  );
})}
          </ul>
        </nav>

        {/* Book Demo Modal */}
        <BookDemoModal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
        />

        {/* Contact Us Modal */}
        <ContactModal
          isOpen={this.state.contactModalIsOpen}
          onClose={this.closeContactModal}
        />
      </>
    );
  }
}

export default Navbar;